import React from 'react';

import { useIntl } from 'react-intl';

import { useFlags } from '@atlaskit/flag/use-flags';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';
import {
	isSandboxHelpCenterBasePath,
	migrationPublishMessages,
	MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM,
} from '@atlassian/company-hub-common/migration-publish-success';

interface MigrationPublishSuccessFlagProps {
	shouldShow?: boolean;
	isSandboxHelpCenter?: boolean;
}

export const MigrationPublishSuccessFlag = ({
	shouldShow,
	isSandboxHelpCenter: isSandboxHelpCenterOverride,
}: MigrationPublishSuccessFlagProps): null => {
	const { formatMessage } = useIntl();
	const { showFlag } = useFlags();

	React.useEffect(() => {
		const currentUrl = new URL(window.location.href);
		const shouldShowPublishSuccessFlag =
			shouldShow ?? currentUrl.searchParams.get(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM) === 'true';
		if (!shouldShowPublishSuccessFlag) {
			return;
		}

		if (shouldShow === undefined) {
			currentUrl.searchParams.delete(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM);
			window.history.replaceState(window.history.state, '', currentUrl);
		}

		const isSandboxHelpCenter =
			isSandboxHelpCenterOverride ?? isSandboxHelpCenterBasePath(currentUrl.pathname);
		const title = formatMessage(
			isSandboxHelpCenter
				? migrationPublishMessages.sandboxHelpCenterPublished
				: migrationPublishMessages.helpCenterPublished,
		);
		showFlag({
			title,
			description: formatMessage(
				isSandboxHelpCenter
					? migrationPublishMessages.sandboxHelpCenterPublishedDescription
					: migrationPublishMessages.helpCenterPublishedDescription,
			),
			isAutoDismiss: true,
			icon: (
				<StatusSuccessIcon label={title} color={token('color.icon.success')} spacing="spacious" />
			),
		});
	}, [formatMessage, isSandboxHelpCenterOverride, shouldShow, showFlag]);

	return null;
};
